import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { compose } from 'redux'
import { connect } from 'react-redux'
import { Flex } from 'reflexbox'
import { Card } from 'react-toolbox/lib/card'

import CSSModules from 'helpers/CSSModulesUtil'
import { getHistoryDateString } from 'helpers/DateUtil'
import StatusColorHoc from './StatusColorHoc'
import TimelineSectionHeader from './TimelineSectionHeader'
import TimelineSection from './TimelineSection'
import PanelSectionHeader from 'components/fulcrum/panelSectionHeader/PanelSectionHeader'
import PanelSection from 'components/fulcrum/panelSection/PanelSection'
import progressBarHoc from 'containers/Async/AsyncProgressBar'

import {
  FETCH_WORKFLOW_HISTORY,
  FETCH_APPROVER_HISTORY,
} from './constants'
import {
  workflowHistorySelector,
  approverHistorySelector,
} from './selectors'
import {
  fetchHistory,
} from './actions'
import {
  currentApprovalSelector,
} from 'containers/Approval/ApprovalPage/selectors'

import styles from './styles.scss'

const mapStateToProps = state => {
  return {
    workflowHistory: workflowHistorySelector(state),
    approverHistory: approverHistorySelector(state),
    currentApproval: currentApprovalSelector(state),
  }
}

const ProgressBar = progressBarHoc(
  [
    FETCH_WORKFLOW_HISTORY,
    FETCH_APPROVER_HISTORY
  ]
)

class HistorySection extends Component {
  static propTypes = {
    workflowHistory: PropTypes.array.isRequired,
    approverHistory: PropTypes.array.isRequired,
  }

  createSections(){
    return this.createHistory().map(
      ([sectionTitle, history], index) => {
        return (
          <TimelineSection
            key={ sectionTitle }
            sectionNumber={ index }
            title={ sectionTitle }
            history={ history }
          />
        )
      }
    )
  }

  createHistory(){
    let history = this.props.workflowHistory.map( ({comment, date, state}) => {
      return { date, state, comment }
    })

    history = this.props.approverHistory.reduce(
      ( list, { date, state, action, name } ) => {
        list.push({ date, state, action, name, comment })
        return list
      },
      history
    ).map(
      ({ date, ...rest }) => {
        return {
          date: new Date(Date.parse(date)),
          ...rest
        }
      }
    ).sort(({ date: date_a}, { date: date_b }) => date_b - date_a)

    return Object.entries(
      history.reduce(
        (sections, historyPoint, index) => {
          let sectionTitle = getHistoryDateString(historyPoint.date)
          let section = sections[sectionTitle] || []
          section.push(historyPoint)
          return {
            ...sections,
            [sectionTitle]: section
          }
        },
        {}
      )
    )
  }

  render() {
    const sections = this.createSections()
    const startHeader = sections.length === 0 ?
      null : StatusColorHoc({title: 'Start'}, TimelineSectionHeader )

    return (
      <PanelSection>
        <PanelSectionHeader label='History Section'/>
        <Card theme={styles}>
          { sections }
          <ProgressBar/>
          <Flex auto column align='center' justify='flex-start'>
            { startHeader }
          </Flex>
        </Card>
      </PanelSection>
    )
  }
}


const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps)
const enhance = compose(
  withConnect,
  withStyles
)

export default enhance(HistorySection)
